import { createReducer, on } from "@ngrx/store";
import { CreateAiAgentsState } from "src/app/common/models/ai-agents.model";
import { EditActions } from "./edit.index";

let initialState: CreateAiAgentsState = {
  data: null,
  isLoading: false,
  error: null,
};

export const EditAiAgentReducer = createReducer(
  initialState,
  on(
    EditActions.editAiAgent,
    (state): CreateAiAgentsState => ({
      ...state,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    EditActions.editAiAgentSuccess,
    (state, { response, action, languageName }): CreateAiAgentsState => ({
      ...state,
      data: {
        ...response,
        ...(action ? { action } : {}),
        ...(languageName ? { languageName } : {}),
      },
      isLoading: false,
      error: null,
    }),
  ),
  on(
    EditActions.editAiAgentError,
    (state, { error }): CreateAiAgentsState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
  on(EditActions.editAiAgent, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(EditActions.clearEditAiAgent, () => initialState),
);
